<oui-dialog-content class="dialog-content">
  <div class="dialog-body">
    <oui-button class="dialog-close-btn" type="icon" oui-dialog-close>
      <oui-icon>close</oui-icon>
    </oui-button>
    <img class="dialog-image" alt="" src="assets/images/dossier_envoye_icon.svg" />

    <div class="subtitle-1">Votre demande de résiliation a bien été sousmise !</div>
    <span>
      Votre lettre de résiliation va vous être transmise pour signature électronique. La
      date de signature fait foi comme date de démission.</span
    >
  </div>
</oui-dialog-content>
